/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const StyledDetailsTable = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;

  &.detailstable-without-shadow {
    box-shadow: none !important;
  }
  &.detailstable-disabled {
    /* border-bottom: 0px; */
    opacity: 0.5;
    pointer-events: none;
    user-select: none;
  }
  &.detailstable-striped .detailstable-row:nth-child(even) {
    background-color: #f6f6f6;
  }
  & .detailstable-head,
  & .detailstable-row {
    font-size: 14px;
    line-height: 24px;
    padding: 12px 18px;
    display: grid;
    grid-template-columns: ${(props) =>
      props.gridTemplateColumns ? props.gridTemplateColumns : 'auto'};
    @media screen and (min-width: 768px) {
      padding: 12px 32px;
    }
  }
  & .detailstable-head {
    background-color: #001140bf;
    color: white;
  }
  & .detailstable-body {
    display: flex;
    flex-direction: column;
  }
`;
